import { useEffect, useState } from "react";
// import "./joinRoom.css";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import toast from "react-hot-toast";
import { db } from "../config/firebaseConfig";
import { UserAuth } from "../context/authContext";

const JoinRoom=() => {
  const [roomId, setRoomId]=useState(localStorage.getItem("roomId")||"");
  const [roomType, setRoomType]=useState("");
  const [role, setRole]=useState(localStorage.getItem("role")||"");
  const { userData }=UserAuth();
  const [isLoading, setIsLoading]=useState(false);

  useEffect(() => {
    if (!roomId) return;
    setIsLoading(true);

    const unsubscribe=db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot(
        (roomSnapshot) => {
          if (roomSnapshot.exists) {
            const data=roomSnapshot.data();
            setRoomType(data.roomType); // Set the room type from Firestore
            setIsLoading(false);
          } else {
            setRoomType("");
            toast.error("Room ID is invalid or does not exist.");
            localStorage.removeItem("roomId");
            window.location.reload();
            setIsLoading(false);
          }
        },
        (error) => {
          console.error("Error fetching room details:", error);
          toast.error("Error fetching room details.");
          localStorage.removeItem("roomId");
          window.location.reload();
          setIsLoading(false);
        },
      );

    return () => unsubscribe();
  }, [roomId]);
  // Join room logic
  const handleJoinRoom=async () => {
    if (!roomId||!role) {
      toast.error("Please fill in all required fields.");
      return;
    }

    setIsLoading(true);
    try {
      const roomRef=db.collection("rooms").doc(roomId);

      const roomSnapshot=await roomRef.get();

      if (!roomSnapshot.exists) {
        toast.error("Room not found. Please enter a valid room ID.");
        localStorage.removeItem("roomId");
        window.location.reload();
        setIsLoading(false);
        return;
      }
      const batch=db.batch(); // Using a batch to perform atomic operations

      // Determine opposite role to remove user from (if switching roles)
      const oppositeRole = role === "participant" ? "miner" : "participant";

      batch.update(roomRef, {
        [`${oppositeRole}s`]: firebase.firestore.FieldValue.arrayRemove(
          userData.publicKey,
        ),
        [`${role}s`]: firebase.firestore.FieldValue.arrayUnion(
          userData.publicKey,
        ),
      });

      // Commit the batch write to Firestore
      await batch.commit();

      // Storing the selected room and role in local storage
      localStorage.setItem("roomId", roomId);
      localStorage.setItem("role", role);

      toast.success("Room joined successfully");

      // Redirect based on role
      if (role === "participant") {
        window.location.href = "/create";
      } else if (role === "miner") {
        window.location.href = "/mempool";
      } else {
        window.location.href = "/joinedroom";
      }
    } catch (error) {
      console.error("Error joining room:", error);
      toast.error("Failed to join room. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6  rounded-lg shadow-md">
      <div className="mb-4">
        <label
          htmlFor="roomId"
          className="block text-2xl text-white font-semibold mb-2"
        >
          Room ID
        </label>
        <input
          type="text"
          id="roomId"
          placeholder="Enter Room ID"
          value={roomId}
          onChange={(e) => {
            e.preventDefault();
            setRoomId(e.target.value);
          }}
          className="form-control "
          disabled={isLoading}
        />
      </div>
      {roomType&&(
        <div className="mb-4">
          <label
            htmlFor="role"
            className="block text-2xl text-white font-semibold mb-2"
          >
            Role:
          </label>
          <select
            id="role"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="form-control"
            disabled={isLoading}
          >
            <option value="">Select Role</option>
            <option value="miner">Miner</option>
            <option value="participant">Participant</option>
          </select>
        </div>
      )}
      <button
        onClick={handleJoinRoom}
        disabled={isLoading||!roomId||!role}
        className={`btn btn-primary font-semibold px-4 py-2 rounded-full ${isLoading||!roomId||!role? "opacity-50 cursor-not-allowed":""
          }`}
      >
        Join Room
      </button>
    </div>
  );
};

export default JoinRoom;
